export const MUTUAL_FUNDS_HOUESE = "MUTUAL_FUNDS_HOUESE";
export const MUTUAL_FUNDS_HOUESE_ERROR = "MUTUAL_FUNDS_HOUESE_ERROR";
export const MUTUAL_FUNDS_HOUESE_HIDE_ERROR = "EXPLORE_FUNDS_HIDE_ERROR";
